export const fontFamily = "trpr-icons";
export const sunrise = "\\e906";
export const cw = "\\e925";
export const arrowRight = "\\e920";
export const itinerary = "\\e924";
export const prev = "\\e917";
export const next = "\\e919";
export const checked = "\\e916";
export const unchecked = "\\e918";
export const filters = "\\e911";
export const overnight = "\\e915";
export const forwardAlt = "\\e90c";
export const road = "\\e912";
export const placeholder = "\\e913";
export const binoculars = "\\e914";
export const camera = "\\e904";
export const web = "\\e922";
export const atlasView = "\\e900";
export const tripPlanner = "\\e901";
export const forward = "\\e902";
export const back = "\\e903";
export const moonrise = "\\e905";
export const reCenter = "\\e907";
export const star = "\\e908";
export const phone = "\\e909";
export const search = "\\e90a";
export const newTab = "\\e90b";
export const alert = "\\e90d";
export const minus = "\\e90e";
export const plus = "\\e90f";
export const close = "\\e910";
export const pdf = "\\e91a";
export const gpx = "\\e91b";
export const email = "\\e91c";
export const time = "\\e91e";
export const marker = "\\e91f";
export const flag = "\\e921";
export const plane = "\\e923";
export const triangle = "\\e91d";
